import * as actions from './Proximity.actions';
import reducer from './Proximity.reducer';
import * as types from './Proximity.types';
import * as selectors from './Proximity.selectors';

export default {
  actions,
  reducer,
  types,
  selectors,
};
